import { useContext } from 'react';
import { I18nContext } from "./shared";
import { useReviews } from "./useReviews";
import { Rating, RatingStar } from "flowbite-react";

export default function ReviewsList({ appId }: { appId: number }) {
  const i18n = useContext(I18nContext);
  const t: any = i18n;
  const { data, loading, error } = useReviews(appId);

  if (loading) return <p>{t.loading}</p>;
  if (error) return <p>{t.error}</p>;
  if (!data || !data.reviews || data.reviews.length === 0) return <p>{t.no_reviews}</p>;

  return (
    <ul className="mt-4">
      {data.reviews.map(r => (
        <li key={r.id} className="mt-2 p-3 rounded border bg-white dark:bg-gray-800">
          <div className="flex justify-between items-start">
            <strong className="text-sm font-medium text-gray-900 dark:text-white">{r.author}</strong>
            <em className="text-xs text-gray-500 dark:text-gray-400">{new Date(r.publishedAt).toLocaleString()}</em>
          </div>
          <p className="mt-2 text-sm text-gray-700 dark:text-gray-300">{r.text}</p>
          <div className="mt-2">
            <Rating>
              {[...Array(5)].map((_, i) => (
                <RatingStar key={i} filled={i < r.score} />
              ))}
              {/* <p className="ml-2 text-sm font-medium text-gray-500 dark:text-gray-400">{r.score} out of 5</p> */}
            </Rating>
          </div>
        </li>
      ))}
    </ul>
  );
}
